export enum Roles {
  Unknown = -1,
  Engineer = 1,
  Admin = 2,
  Technician = 4,
  none = 0
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/model/enum/roles.ts